/**
 * Retrieves the maximum value from array of number
 */
const maxOf = <T extends number>(
    numbers: readonly T[],
): (typeof numbers)[0] extends undefined ? 0 : T => {
    return numbers.reduce((max, next) => {
        return (max < next ? next : max) as T;
    }, numbers[0] || 0) as (typeof numbers)[0] extends undefined ? 0 : T;
};

/**
 * Retrieves the minimum value from array of number
 */
const minOf = <T extends number>(
    numbers: readonly T[],
): (typeof numbers)[0] extends undefined ? 0 : T => {
    return numbers.reduce((min, next) => {
        return min > next ? next : min;
    }, numbers[0] || 0) as (typeof numbers)[0] extends undefined ? 0 : T;
};

function minAndMaxOf(prices: [number, ...number[]]): {
    min: number;
    max: number;
};
function minAndMaxOf(
    values: number[],
): { min: number; max: number } | undefined;
function minAndMaxOf(
    values: number[],
): { min: number; max: number } | undefined {
    if (!values.length) return undefined;
    let minValue = values[0];
    let maxValue = values[0];
    for (const value of values) {
        if (value < minValue) {
            minValue = value;
        }
        if (value > maxValue) {
            maxValue = value;
        }
    }
    return { min: minValue, max: maxValue };
}

export { maxOf, minAndMaxOf, minOf };
